import BaseHelper from './moment-base';
import moment from 'moment';

export default class MomentFromNow extends BaseHelper {
  compute([date]) {
    super.compute(...arguments);
    return moment(date).fromNow();
  }
}
